<!-- eslint-disable vue/multi-word-component-names -- single-word SFC name matches the route, renaming breaks router refs -->
<template>
  <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white/90">Prihláste sa do svojho účtu</h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-xs sm:rounded-lg sm:px-10 dark:bg-gray-900">
        <form class="space-y-6" @submit.prevent="login">
          <div v-if="errorMsg" class="flex items-center justify-between py-3 px-4 bg-red-500 text-white rounded-sm">
            {{ errorMsg }}
            <span @click="errorMsg = ''" class="rounded-full transition-colors cursor-pointer hover:bg-[rgba(0,0,0,0.2)]">
              <svg xmlns="http://www.w3.org/2000/svg" class="size-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </span>
          </div>
          <div>
            <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-300"> Emailová adresa </label>
            <div class="mt-1">
              <Input id="email" v-model="user.email" type="email" autocomplete="email" required
                class="h-11 w-full rounded-[10px] border-gray-300 bg-white px-4 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
            </div>
          </div>

          <div>
            <label for="password" class="block text-sm font-medium text-gray-700 dark:text-gray-300"> Heslo </label>
            <div class="mt-1">
              <Input id="password" v-model="user.password" type="password"
                autocomplete="current-password" required
                class="h-11 w-full rounded-[10px] border-gray-300 bg-white px-4 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
            </div>
          </div>
          <div>
            <Button type="submit" class="w-full">
              Prihlásiť sa
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import store from '@/store'
import { useRouter } from 'vue-router'
import { ref } from 'vue'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

const router = useRouter()

const user = {
  email: '',
  password: '',
  remember: false,
}

const errorMsg = ref()

function login() {
  store
    .dispatch('loginUser', user)
    .then(() => {
      router.push({
        name: 'Dashboard',
      })
    })
    .catch(err => {
      errorMsg.value = err.response.data.error // response data is from store actions
    })
}
</script>
